<template>
  <div
    v-if="!isLogged"
    class="auth">
    <div class="auth__login">
      <a
        class="auth__link"
        :href=sofomLogin
        :class="this.$route.path === '/login' ?
              'auth__link--active' : ''">
        <img
          alt="Ingresa"
          src="https://secure-cdn.cumplo.cl/assets/cumplo2017/ingresa-icon-1a87015a52235cb7d884a1ff4030f21c.svg">
        <span class="auth__link__text--ml"><b>Iniciar sesión</b></span>
      </a>
    </div>
  </div>
  <div v-else>
    <span class="user-info user-info__name--size">Bienvenido(a) {{ userName }}</span>
    <br>
    <span class="user-info user-info__date--size">Inicio de sesión: {{ lastLogin | formatDate }}</span>
  </div>
</template>

<script>
export default {
  name: 'LoginMobile',
  filters: {
    formatDate: function (value) {
      const date = new Date(value)
      const hours = date.getHours()
      const minutes = date.getMinutes()
      var strTime = hours + ':' + minutes
      return (
        date.getDate() +
        '-' + (date.getMonth() + 1) +
        '-' + date.getFullYear() + ' ' +
        strTime
      )
    }
  },
  props: {
    isLogged: {
      type: Boolean,
      required: true,
      default: false
    },
    userName: {
      type: String
    },
    lastLogin: {
      type: String
    }
  },
  data () {
    return {
      sofomLogin: `/login`,
      sofomSignup: `/registro`
    }
  }
}
</script>

<style lang="scss" scoped>
  .user-info {
    color: white;
  }

  .user-info__name--size {
    font-size: .8em;
    font-weight: bold;
  }

  .user-info__date--size {
    font-size: .7em;
  }

  .auth {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2em;
  }

  .auth__link {
    color: $white;
    font-size: .7em;
  }

  .auth__link:hover,
  .auth__link--active {
    color: #b0de83;
  }

  .auth__link__text--ml {
    margin-left: .3em;
  }

  .auth__signup--ml {
    margin-left: 2.2em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Navigation/Menu/Mobile/LoginMobile.vue